/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import * as CONSTANTS from '../../../../../../SharedModules/AppConstants';
import {
  autoFormateDate,
} from '../../../../../../SharedModules/utilities/utilities';
import {
  INVALID_INVOICE_NUM,
  INVOCE_NOT_FOUND,
} from '../../../../../../SharedModules/Errors/constantMessageData';

import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { quarterFormatter } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import { manuFactureHead } from '../../../../../../SharedModules/Table/tableHead';
import { getUserDefaults } from '../../../../UserDefault/store/actions';
import {
  unfreezeInvoice,
  getManufacturersByPQR,
  getMaxQuarterForFreezeDt,
  getRebateProgramCode,
  setUnfreezeInvoiceData,
  dispatchManufacturersByPQR,
  dispatchUnfreezeInvoiceData,
  setErrorMessages,
} from '../Store/actions';

function RecordMailingDate() {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);

  const rebateProgramCode = useSelector(
    (state) => state.sharedState.UnfreezeInvoiceReducer?.rebateProgramCode?.data
  );

  const defaultQtrUnfreezeInv = useSelector(
    (state) =>
      state.sharedState.UnfreezeInvoiceReducer?.defaultQtrUnfreezeInv?.data
  );

  const manufacturersByPQR = useSelector(
    (state) => state.sharedState.UnfreezeInvoiceReducer?.manufacturersByPQR
  );

  const unfreezeInvoiceData = useSelector(
    (state) => state.sharedState.UnfreezeInvoiceReducer?.unfreezeInvoiceData
  );

  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const saveOrUpdateMessage = useSelector(
    (state) =>
      state.sharedState.UnfreezeInvoiceReducer?.unfreezeInvoiceResponseData
  );

  const errorMessages = useSelector(
    (state) => state.sharedState.UnfreezeInvoiceReducer?.errorMessages
  );

  const getRebateProgramCodeValue = (values) => {
    dispatch(getRebateProgramCode(values));
  };

  const handleErrorMessages = (messages) => {
    dispatch(setErrorMessages(messages));
  };

  const isNumber = (evt) => {
    const event = evt || window.event;
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      //handleErrorMessages([INVALID_INVOICE_NUM]);
      return false;
    }
    handleErrorMessages([]);
    return true;
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    setSuccessMessages([]);
    getUserDefaultValues(logInUser);
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setUnfreezeInvoiceData({
        ...unfreezeInvoiceData,
        forAllMfg: false,
        quarter: !unfreezeInvoiceData?.quarter
          ? defaultQtrUnfreezeInv
          : unfreezeInvoiceData?.quarter,
        defInvoiceSelectModeCd: !unfreezeInvoiceData?.defInvoiceSelectModeCd
          ? UserDefaultValues?.defInvoiceSelectModeCd
          : unfreezeInvoiceData?.defInvoiceSelectModeCd,
        planType: !unfreezeInvoiceData?.planType
          ? UserDefaultValues?.planTypeCd
          : unfreezeInvoiceData?.planType,
        rebateProgramCode: !unfreezeInvoiceData?.rebateProgramCode
          ? UserDefaultValues?.rebateProgramCd
          : unfreezeInvoiceData?.rebateProgramCode,
      })
    );
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/unfreezeInvoice') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  useEffect(() => {
    if (defaultQtrUnfreezeInv) {
      dispatch(
        setUnfreezeInvoiceData({
          ...unfreezeInvoiceData,
          quarter: !unfreezeInvoiceData?.quarter
            ? defaultQtrUnfreezeInv
            : unfreezeInvoiceData?.quarter,
          defInvoiceSelectModeCd: !unfreezeInvoiceData?.defInvoiceSelectModeCd
            ? UserDefaultValues?.defInvoiceSelectModeCd
            : unfreezeInvoiceData?.defInvoiceSelectModeCd,
          planType: !unfreezeInvoiceData?.planType
            ? UserDefaultValues?.planTypeCd
            : unfreezeInvoiceData?.planType,
          rebateProgramCode: !unfreezeInvoiceData?.rebateProgramCode
            ? UserDefaultValues?.rebateProgramCd
            : unfreezeInvoiceData?.rebateProgramCode,
        })
      );
    }
  }, [defaultQtrUnfreezeInv]);

  useEffect(() => {
    setSuccessMessages([]);
    handleErrorMessages([]);
    if (saveOrUpdateMessage === '') {
      setSpinnerLoader(false);
      setSuccessMessages([CONSTANTS.INVOICE_UNFREEZE_SUCCESS]);
    } else if (saveOrUpdateMessage?.error === 'API failed') {
      setSpinnerLoader(false);
      handleErrorMessages([CONSTANTS.ERR_PROCESSING_REQ]);
    } else if (saveOrUpdateMessage) {
      setSpinnerLoader(false);
      let errorMessageList = [];
      if (typeof saveOrUpdateMessage === 'object') {
        Object.keys(saveOrUpdateMessage).forEach((key) => {
          if (typeof saveOrUpdateMessage[key] === 'string')
            errorMessageList.push(
              `${key.replace(/^\w/, (char) => char.toUpperCase())} ${
                saveOrUpdateMessage[key]
              }`
            );
        });
      } else if (typeof saveOrUpdateMessage === 'string') {
        errorMessageList = [saveOrUpdateMessage];
      }
      handleErrorMessages(errorMessageList);
    }
  }, [saveOrUpdateMessage]);

  useEffect(() => {
    if (unfreezeInvoiceData?.planType) {
      getRebateProgramCodeValue(unfreezeInvoiceData?.planType);
    }
  }, [unfreezeInvoiceData?.planType]);

  const onCellClicked = (e) => {
    setSelected([e.data.mfgId]);
  };
const [fieldErrors, setFieldErrors] = useState({
  quarter: '',
});
  const validateInvoiceCalcReq = () => {
    const errorMessage = [];
    if (
      unfreezeInvoiceData?.rebateProgramCode === '' ||
      unfreezeInvoiceData?.rebateProgramCode == null ||
      unfreezeInvoiceData?.rebateProgramCode === '-1'
    ) {
      errorMessage.push(CONSTANTS.REBATE_PGM_REQUIRED);
    }
    if (
      unfreezeInvoiceData?.quarter === '' ||
      unfreezeInvoiceData?.quarter == null
    ) {
      errorMessage.push(CONSTANTS.QUARTER_REQUIRED);
    }
    if (
      unfreezeInvoiceData?.quarter !== '' &&
      unfreezeInvoiceData?.quarter != null &&
      !quarterFormatter(unfreezeInvoiceData?.quarter)
    ) {
      errorMessage.push(CONSTANTS.QUARTER_FORMAT_ERROR);
    }
    if (errorMessage.length > 0) {
      handleErrorMessages(errorMessage);
      dispatch(dispatchManufacturersByPQR([]));
      return false;
    }
    handleErrorMessages([]);
    return true;
  };
const handleBlur = (e) => {
  const { name, value } = e.target;

  if (name === 'quarter') {
    const formattedQuarter = autoFormateDate(value.toUpperCase());

    dispatch(
      setUnfreezeInvoiceData({
        ...unfreezeInvoiceData,
        [name]: formattedQuarter,
      })
    );

    const isValid = quarterFormatter(formattedQuarter);

    // Update field-level error
    setFieldErrors((prev) => ({
      ...prev,
      quarter: !isValid ? CONSTANTS.QUARTER_FORMAT_ERROR : '',
    }));

    // Update global errorMessages if invalid
    if (!isValid) {
      handleErrorMessages([CONSTANTS.QUARTER_FORMAT_ERROR]);
    } else {
      handleErrorMessages([]);
    }
  }
};
  const handlerUnfreezeInvoiceData = (e) => {
    if (e.target.name === 'forAllMfg') {
      dispatch(
        setUnfreezeInvoiceData({
          ...unfreezeInvoiceData,
          [e.target.name]: e.target.checked,
        })
      );
    } else {
      dispatch(
        setUnfreezeInvoiceData({
          ...unfreezeInvoiceData,
          [e.target.name]: e.target.value,      
          ...('planType' in unfreezeInvoiceData &&
            e.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
    }
  };

  const searchManufacturers = () => {
    if (unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM') {
      if (validateInvoiceCalcReq()) {
        setSelected([]);
        dispatch(getManufacturersByPQR(unfreezeInvoiceData));
      }
    } else if (unfreezeInvoiceData?.defInvoiceSelectModeCd === 'IN') {
      setSelected([]);
      dispatch(getManufacturersByPQR(unfreezeInvoiceData));
    }
  };

const processUnfreezeInvoice = () => {
  const mode = unfreezeInvoiceData?.defInvoiceSelectModeCd;

  if (mode === 'PQM') {
    if (!validateInvoiceCalcReq()) return;

    const isAllMfg = unfreezeInvoiceData?.forAllMfg;
    const mfgId = isAllMfg ? null : selected;

    if (!isAllMfg && (!mfgId || (Array.isArray(mfgId) && mfgId.length === 0))) {
      handleErrorMessages([CONSTANTS.MFG_REQ]);
      return;
    }

    const payload = {
      planType: unfreezeInvoiceData.planType,
      rebateProgramCd: unfreezeInvoiceData.rebateProgramCode,
      selectedBy: 'QtrOrMfg',
      isAllFrozenInvoicesForQtr: isAllMfg,
      quarter: unfreezeInvoiceData.quarter,
      mfgId: mfgId,
    };

    setSuccessMessages([]);
    handleErrorMessages([]);
    setSpinnerLoader(true);
    dispatch(unfreezeInvoice(payload));

    // ✅ Only clear the Redux state AFTER dispatch
    dispatch(dispatchUnfreezeInvoiceData(undefined));

  } else if (mode === 'IN') {
    if (!unfreezeInvoiceData?.invoiceNum) {
      handleErrorMessages([CONSTANTS.INVOICE_NUM_REQ]);
      return;
    }

    const payload = {
      rebateProgramCd: null,
      mfgId: null,
      planType: null,
      quarter: null,
      invoiceNumber: unfreezeInvoiceData.invoiceNum,
      isAllFrozenInvoicesForQtr: false,
      selectedBy: 'IN',
    };

    setSuccessMessages([]);
    handleErrorMessages([]);
    setSpinnerLoader(true);
    dispatch(unfreezeInvoice(payload));
  }
};

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space pb-0">
        {spinnerLoader && <Spinner load={spinnerLoader} />}
        <CustomSeparator
          parent1="System"
          parent2="Technical Window"
          parent3="Online Fixes"
          parent4="Unfreeze Invoice"
        />
        <DisplayErrorMessages errorMessages={errorMessages} />
        <DisplaySuccessMessages successMessages={successMessages} />
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend
                    className="same-font-family"
                    id="demo-row-radio-buttons-group-label"
                  >
                    Select by
                  </legend>
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="defInvoiceSelectModeCd"
                            value={
                              unfreezeInvoiceData?.defInvoiceSelectModeCd || ''
                            }
                            onChange={handlerUnfreezeInvoiceData}
                          >
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="PQM"
                              label="Program,Quarter,Manufacturer"
                              data-test="PQM"
                              control={
                                <Radio
                                  onChange={(e) => {
                                    handlerUnfreezeInvoiceData(e);
                                  }}
                                />
                              }
                            />
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="IN"
                              label="Invoice Number"
                              data-test="Invoice Number"
                              control={
                                <Radio
                                  onChange={(e) => {
                                    setSuccessMessages([]);
                                    handleErrorMessages([]);
                                    handlerUnfreezeInvoiceData(e);
                                  }}
                                />
                              }
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              {unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM' && (
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">Plan Type</legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="planType"
                              onChange={handlerUnfreezeInvoiceData}
                              value={unfreezeInvoiceData?.planType || ''}
                              required
                            >
                              <FormControlLabel
                                style={{ marginRight: '20px' }}
                                value="FD"
                                control={<Radio />}
                                label="Medicaid"
                                data-test="Medicaid"
                              />
                              <FormControlLabel
                                style={{ marginRight: '10px' }}
                                value="COMM"
                                control={<Radio />}
                                label="Commercial"
                                data-test="Commercial"
                              />
                              <FormControlLabel
                                style={{ marginRight: '50px' }}
                                value="ST"
                                control={<Radio />}
                                label="State"
                                data-test="State"
                              />
                              <FormControlLabel
                                value="SUPP"
                                control={<Radio />}
                                label="Supplemental"
                                data-test="Supplemental"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              )}
              {unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM' && (
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend
                      className="same-font-family"
                      htmlFor="rebateProgramCode"
                    >
                      Rebate Program
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          label="Rebate Program"
                          fullWidth
                          select
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            id: 'rebateProgramCode',
                          }}
                          required
                          onChange={handlerUnfreezeInvoiceData}
                          name="rebateProgramCode"
                          id="rebateProgramCode"
                          value={unfreezeInvoiceData?.rebateProgramCode || '-1'}
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {rebateProgramCode &&
                          rebateProgramCode.length &&
                          rebateProgramCode.length > 0
                            ? rebateProgramCode.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.rebateProgramCd}
                                    value={item.rebateProgramCd}
                                  >
                                    {item.rebateProgramCd} {'|'}{' '}
                                    {item.shortDescr}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>
              )}
              {unfreezeInvoiceData?.defInvoiceSelectModeCd === 'IN' && (
                <>
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Invoice Number
                      </legend>
                      <div className="form-wrapper p-0">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            label="Invoice Number"
                            fullWidth
                            required
                            placeholder=""
                            value={unfreezeInvoiceData?.invoiceNum || ''}
                            name="invoiceNum"
                            id="invoiceNum"
                            onChange={handlerUnfreezeInvoiceData}
                            onKeyPress={isNumber}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 38 }}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-sm-4 pr-4">
                    <div className="btn-wrapper">
                      <div className="float-right hide-on-print">
                        <Button
                          className="btn-success same-font-family frr-btn-width-17 mt-4"
                          onClick={processUnfreezeInvoice}
                        >
                          <SVGComponent iconName="Create-new-icon" /> Unfreeze
                          Invoice
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM' && (
              <>
                <div className="row">
                  <div className="col-sm-8">
                    <div className="form-wrapper">
                      <div
                        className="mui-custom-form with-select min-md"
                        style={{ width: '100%', flex: '1 1' }}
                      >
                        <div className="sub-radio text-black sub-label">
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                name="forAllMfg"
                                checked={unfreezeInvoiceData?.forAllMfg}
                                onChange={(e) => {
                                  handlerUnfreezeInvoiceData(e);
                                  if (!e.target.checked) {
                                    searchManufacturers();
                                  }
                                }}
                              />
                            }
                            label="All Frozen Invoices for this Quarter"
                          />
                        </div>
                      </div>
                      <div className="mui-custom-form with-select override-width-55">
                        <TextField
                          id="Quarter"
                          label="Quarter"
                          fullWidth
                          placeholder=""
                          inputProps={{ maxlength: 6 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required
                          name="quarter"
                          value={
                            unfreezeInvoiceData?.quarter?.toUpperCase() || ''
                          }
                          onChange={handlerUnfreezeInvoiceData}
                          onBlur={handleBlur} 
                           helperText={fieldErrors.quarter}
                            error={Boolean(fieldErrors.quarter)}
                        
                        

                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="btn-wrapper hide-on-print mt-4">
                      <Button
                        className="btn-success same-font-family btn btn-primary float-right"
                        onClick={processUnfreezeInvoice}
                      >
                        <SVGComponent iconName="Create-new-icon" /> Unfreeze
                        Invoice
                      </Button>
                      {unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM' &&
                        !unfreezeInvoiceData?.forAllMfg && (
                          <Button
                            className="btn-success same-font-family btn btn-primary float-right"
                            onClick={searchManufacturers}
                          >
                            <SVGComponent iconName="Icon-search" /> Search
                          </Button>
                        )}
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
              </>
            )}
          </>
        )}
      </div>

      {!unfreezeInvoiceData?.forAllMfg &&
        unfreezeInvoiceData?.defInvoiceSelectModeCd === 'PQM' && (
          <div className="panel tBillPanel-space pb-0">
            <div className="FRR-custom-table tbl-manufacturer-home">
              <Grid
                gridHeight={fullScreenView ? '100vh' : 350}
                rowData={manufacturersByPQR?.data || []}
                columnDefs={manuFactureHead}
                onSelect={onCellClicked}
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                applyFilter={false}
                exportFile
                childPopup
                data-testid="onEditingStopped"
                fileName="UnfreezeInvoice"
                handleFullScreenViewClick={handleFullScreenView}
              />
            </div>
          </div>
        )}
    </div>
  );
}
export default withRouter(RecordMailingDate);
